import checkPromoReferralCode from './checkPromoReferralCode'

const websiteLib = {
  checkPromoReferralCode
}

export default websiteLib
